export default __webpack_public_path__ + "static/photo-florent-ventura-6d78a055faafb5e8e9476886fe425b92.webp";